<div class="users overflow-y-auto overflow-x-hidden">
	<app-header-views
		[title]="translateUsers.title || ''"
		[textButton]="translateUsers.buttonNew || ''"
		(actionButton)="openNewUser()"
	></app-header-views>
	<div class="body">
		<app-table-users
			[userTable]="userTable"
			[pagination]="pagination"
			[loading]="isLoading"
			[heigthTable]="154"
			[columnsFilter]="columns"
		></app-table-users>
	</div>
</div>
